module.exports = __webpack_public_path__ + "img/i-logo-partner.0f7abff4.png";